module.exports = __webpack_public_path__ + "static/media/Bird6.1401fab5.jpg";